import {FC, useCallback, useMemo, useState} from 'react'
import {useQuery} from 'react-query'
import {ChildrenInterface} from '../../../global'
import {
  NotificationsContext,
  NotificationsContextType,
  NotificationsInitialState,
  NotificationsResponse,
  ToastState,
} from './types'
import SetupAxios from '../../../setup/axios/SetupAxios'

const NOTIFICATIONS = process.env.REACT_APP_NOTIFICATIONS || 'notifications'

const fetchData = async (endpoint: string): Promise<NotificationsResponse> => {
  try {
    const response = await SetupAxios.get<NotificationsResponse>(endpoint)
    return response.data
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error
  }
}

export const NotificationsProvider: FC<ChildrenInterface> = ({children}) => {
  const [toast, setToast] = useState<ToastState>({
    type: '',
    text: {
      title: '',
      message: '',
    },
  })

  const {data, refetch} = useQuery<NotificationsResponse>(
    'Notifications',
    () => fetchData(NOTIFICATIONS),
    {
      onError: (error) => {
        console.error('Error fetching notifications:', error)
      },
    }
  )

  const notifications = useMemo<Partial<NotificationsResponse>>(
    () => data || NotificationsInitialState,
    [data]
  )

  const refreshNotifications = useCallback(() => {
    refetch()
  }, [refetch])

  const contextValue = useMemo<NotificationsContextType>(
    () => ({
      notifications,
      refreshNotifications,
      toast,
      setToast,
    }),
    [notifications, refreshNotifications, toast]
  )

  return (
    <NotificationsContext.Provider value={contextValue}>
      {children}
    </NotificationsContext.Provider>
  )
}
